import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INCIDENTORIGIN_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.IncidentOrigin.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const INCIDENTORIGIN_CONFIG = {
  entityName: 'IncidentOrigin',
  localizationKey: 'Planning::Entity.IncidentOrigin',
  fields: INCIDENTORIGIN_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.IncidentOrigins',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
